import { httpCreate } from './http';
const http = httpCreate('/srv/rtmp-pull');
export const rtmpPull = {
	// 添加拉流配置
	addPullFlow(data) {
		return http.post('', data);
	},
	// 删除拉流配置
	delPullFlow(pullId) {
		return http.delete(`/${pullId}`);
	},
	// 修改拉流配置
	updatePull(pullId, data) {
		return http.put(`/${pullId}`, data);
	},
	//获取获取拉流配置列表
	getPullFlow(params) {
		return http.get('/list', { params });
	},
	// 开启拉流配置
	openPull(pullId) {
		return http.put(`/open/${pullId}`);
	},
	// 关闭拉流配置
	closePull(pullId) {
		return http.put(`/close/${pullId}`);
	},
	// 获取直播标题
	getactivityTitle(activityId) {
		return http.get(`/activity/search/${activityId}`);
	},
	// 2021-3-31新版本拉流 ↓
	// 保存拉流配置
	savePullFlowNew(activityId, data, open) {
		return http.put(`/activity/${activityId}?open=${open}`, data);
	},
	// 获取拉流配置
	getPullFlowNew(activityId) {
		return http.get(`/activity/${activityId}`);
	},
	// 开启直播间拉流任务
	openPullFlowNew(activityId) {
		return http.put(`/open/activity/${activityId}`);
	},
	// 关闭直播间拉流任务
	closePullFlowNew(activityId) {
		return http.put(`/close/activity/${activityId}`);
	},
	// 2021-3-31↑
};
